import ExpirationPaymentButtons from "../ExpirationPaymentButtons/ExpirationPaymentButtons"
import CloseButton from "../../../components/CloseButton/CloseButton"
import useStrings from "../../../localization/useStrings"
import useQueryParams from "../../../hooks/useQueryParams"
import { useExpiration } from "../../../context/expirationContext"
import { useAppState } from "../../../context/appStateContext"
import { usePurchase } from "../../../context/purchaseContext"
import styles from "./ExpirationStep1.module.scss"
import { Background, Features } from "../BubblePaywallSVG/BubblePaywallSVG"
import { PlanToggleButton } from "../PlanToggleButton/PlanToggleButton"
import { CompareButton } from "../CompareButton/CompareButton"

interface Props {
  onLifetimeClick: () => void
}

const ExpirationStep1 = ({ onLifetimeClick }: Props) => {
  const strings = useStrings()
  const queryParams = useQueryParams()
  const { actions } = useExpiration()
  const { state: appState } = useAppState()
  const { state: purchaseState } = usePurchase()

  const showUltimateToggle = queryParams.showUltimateInExpiration
  const isUltimate = purchaseState.ultimateSelected

  const handleClose = () => {
    // Hide the warmup page to show the main content (second step)
    actions.hideWarmup()
  }

  const featuresText = isUltimate
    ? strings.bubbleExpiration.everyUltimateFeature
    : strings.bubbleExpiration.everyPremiumFeature

  return (
    <div className={styles.container}>
      <div
        className={styles.headerInset}
        style={{ height: appState.initialData?.topInset ?? 0 }}
      />
      <CloseButton
        className={styles.closeButton}
        onClick={handleClose}
        style={{ top: `${(appState.initialData?.topInset ?? 0) + 12}px` }}
      />
      {showUltimateToggle && (
        <div
          className={styles.compareButtonWrapper}
          style={{ top: `${(appState.initialData?.topInset ?? 0) + 12}px` }}
        >
          <CompareButton />
        </div>
      )}
      {/* Header Content */}
      <div className={styles.header}>
        <label className={styles.title}>
          {strings.bubbleExpiration.expiredTitle}
        </label>
        <label className={styles.subtitle}>
          {showUltimateToggle
            ? isUltimate
              ? strings.bubbleExpiration.expiredSubtitleUltimate
              : strings.bubbleExpiration.expiredSubtitlePremium
            : strings.bubbleExpiration.expiredSubtitle}
        </label>
      </div>
      <div className={styles.waveBackground}>
        <Background
          primaryColor="var(--wave-primary-color)"
          useGradient={isUltimate}
        />
      </div>
      <div
        className={styles.bottomContent}
        style={{
          background: isUltimate
            ? "linear-gradient(90deg, var(--ultimate-gradient-start) 0%, var(--ultimate-gradient-end) 100%)"
            : undefined,
        }}
      >
        <div className={styles.featuresContainer}>
          <Features
            trashRecovery={strings.bubbleExpiration.trashRecovery}
            noAds={strings.bubbleExpiration.noAds}
            spaceSaver={strings.bubbleExpiration.spaceSaver}
            cloudVault={strings.bubbleExpiration.cloudVault}
            everyPremiumFeature={featuresText}
          />
        </div>

        {showUltimateToggle && (
          <div className={styles.toggleButtonContainer}>
            <PlanToggleButton />
          </div>
        )}

        <div className={styles.paymentSection}>
          <ExpirationPaymentButtons onLifetimeClick={onLifetimeClick} />
        </div>
        <div
          className={styles.footerInset}
          style={{ height: appState.initialData?.originalBottomInset ?? 0 }}
        />
      </div>
    </div>
  )
}

export default ExpirationStep1
